//this is the mock data provided to us to conduct the task, no changes has been made to it
//commented code in the first item apply to the rest as well
export const routes = [
  {
    //the unique identifier of the route
    id: "route-1",
    //the title of the route
    title: "Downtown Express",
    //the total duration of it
    duration: "25 mins",
    //the amount of stops within it
    stops: 5,
    //the cost of the route
    price: 245.5,
    //basic description of the route
    description:
      "The quickest way to the heart of the city, with minimal stops.",
  },
  {
    id: "route-2",
    title: "Scenic Coastal Line",
    duration: "55 mins",
    stops: 8,
    price: 255.75,
    description: "Enjoy breathtaking views of the coastline as you travel.",
  },
  {
    id: "route-3",
    title: "Suburban Shuttle",
    duration: "45 mins",
    stops: 6,
    price: 99.0,
    description: "Connects the suburbs with downtown, running every half hour.",
  },
  {
    id: "route-4",
    title: "Night Owl",
    duration: "30 mins",
    stops: 4,
    price: 56.65,
    description:
      "Operates after midnight, serving all major nightlife districts.",
  },
];
